import Lottie from 'lottie-react';

export default function CallUs({ path, size = 40 }) {
    return <Lottie path={path} loop autoplay style={{ width: size, height: size }} />;
}

// /lottie/call-us.json
